// extracted by mini-css-extract-plugin
module.exports = {"container":"WhiteBox_container__uOBnV"};